<template>
  <div class="dljsgcdzaqxpj">
    <div class="calc-templete">
      <h6>全国电力建设工程地震安全性评价费计算模版</h6>
      <t-form :data="formData" :rules="rules" ref="form" @reset="onReset" @submit="onSubmit">
        <t-row style="height: auto;align-items: stretch;">
          <t-col :span="6"
            style="border-right: 1px solid #DADDE1;padding-left: 40px;padding-right: 140px;padding-bottom: 50px;height: auto;">
            <div class="left-top-title"><span>电力建设工程地震安全性评价</span></div>
            <t-form-item label="计算依据">
              <a class="file-name" v-if="fileList" @click="fileOpenDialog(fileList.url)">{{ fileList.fileName }}</a>
              <a v-else class="no-file-name">无文件</a>
              <!-- <t-input v-model="formData.projectName" placeholder="请输入工程名称" ></t-input> -->
            </t-form-item>
            <t-form-item label="工程名称" name="projectName">
              <t-input v-model="formData.projectName" placeholder="请输入工程名称"></t-input>
            </t-form-item>

            <t-form-item label="工程分类">
              <!-- <t-input v-model="formData.subcategor" placeholder="请输入细分类型"></t-input> -->
              <t-select v-model="projectClassify" placeholder="请选择工程分类" @change="changeprojectClassify"
                default-value="200">
                <t-option key="火力发电工程" label="火力发电工程" value="火力发电工程" />
                <t-option key="电网工程" value="电网工程" label="电网工程"></t-option>
              </t-select>
              <t-popup placement="right" showArrow>
                <template #content>
                  <div>请确定好计算的类型</div>
                </template>
                <t-button theme="default" variant="outline" class="coefficient">查看说明
                </t-button>
              </t-popup>
            </t-form-item>

            <t-form-item label="工程类型">
              <t-select v-model="projectType" placeholder="请输入工程类型" @change="changeprojectType" default-value="200">
                <t-option v-for="item in optionsprojectType" :value="item.value" :key="item.value"
                  :label="item.label" />
              </t-select>
              <t-popup placement="right" showArrow>
                <template #content>
                  <div>请确定好计算的类型</div>
                </template>
                <t-button theme="default" variant="outline" class="coefficient">查看说明
                </t-button>
              </t-popup>
            </t-form-item>
            <t-form-item :label="this.isxldkygc ? '工作量' : '电站个数'" name="money">
              <t-input v-model="formData.money" placeholder="请输入电站个数" :suffix="this.isxldkygc ? '项' : '个'"
                type="number"></t-input>
            </t-form-item>
            <t-form-item label="细分类型" name="subcategor" v-if="!this.isxldkygc">
              <!-- <t-input v-model="formData.subcategor" placeholder="请输入细分类型"></t-input> -->
              <t-select v-model="formData.subcategor" placeholder="请输入细分类型" @change="changeSubcategor">
                <t-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
              </t-select>
              <t-popup placement="right" showArrow>
                <template #content>
                  <div>请确定好计算的类型</div>
                </template>
                <t-button theme="default" variant="outline" class="coefficient">查看说明

                </t-button>
              </t-popup>


            </t-form-item>

            <t-form-item label="费用基价" name="costBasePrice">
              <t-input-number v-model="formData.costBasePrice" placeholder="请输入费用基价" suffix="万元" :status="inputStatus"
                :tips="tips" :min="20" :max="30" theme="normal"></t-input-number>
              <t-button theme="default" variant="outline" class="coefficient"><span>{{ costBasePriceLimit }}</span>
              </t-button>
            </t-form-item>

            <t-form-item label="调整系数" name="coefficient">
              <t-input-number v-model="formData.coefficient" placeholder="调整系数" :status="inputStatus3" :tips="tips3" :min="0" theme="normal"></t-input-number>
              <t-popup placement="right" showArrow>
                <template #content>
                  <div>
                    注：<br />
                    1.职业病危害预评价已包含在此项费用中。<br />
                    2.其他容量等级发电机组可结合实际情况参照执行。
                  </div>
                </template>
                <t-button theme="default" variant="outline" class="coefficient">查看说明
                  <img src="@/assets/icon/Vector.svg"
                    style="width: 4px;height: 7px;left: 4px;top: 8px;position: relative;">
                </t-button>
              </t-popup>
            </t-form-item>

            <t-form-item label="让利利率" name="discountRate">
              <t-input-number v-model="discountRate" placeholder="" label="-" suffix="%" :status="inputStatus2"
                :tips="tips2" :min="0" :max="100" theme="normal" />
            </t-form-item>
            <t-button theme="primary" type="submit" class="submit">点击计算（消耗2积分）</t-button>
          </t-col>
          <t-col :span="6" style="padding-left: 106px;padding-right: 70px;padding-bottom: 50px;">
            <div class="right-top-title"><span>计算结果</span></div>
            <t-form-item label="收费基价" name="subtotal">
              <t-input v-model="formData.subtotal" placeholder="" disabled suffix="元"></t-input>
            </t-form-item>
            <t-form-item label="基本收费" name="basicCharge">
              <t-input v-model="formData.basicCharge" placeholder="" disabled suffix="元"></t-input>
            </t-form-item>
            <t-form-item label="折前地震安全评价费" name="assessmentFee">
              <t-input v-model="formData.assessmentFee" placeholder="" disabled suffix="元"></t-input>
            </t-form-item>
            <t-form-item label="计算过程">
              <t-textarea v-model="jsgc" placeholder="" disabled :autosize="{ minRows: 3, maxRows: 5 }"></t-textarea>
            </t-form-item>

            <t-form-item label="折后地震安全评价费" name="result">
              <t-input v-model="formData.result" placeholder="" disabled suffix="元" @change="resultChange"></t-input>
            </t-form-item>
            <t-form-item label="金额大写" name="resultChinese">
              <t-input v-model="resultChinese" placeholder="" disabled></t-input>
            </t-form-item>

            <t-button class="download" @click="downLoadWord" :disabled="!formData.result"
            :loading="downLoading">查看计算过程和报告（消耗5积分）</t-button>
          </t-col>
        </t-row>

      </t-form>

    </div>
    <div class="calc-rules">
      <t-row>
        <t-col :span="6" style="border-right: 1px solid #DADDE1;">
          <h4><span>计算范围和计算公式</span></h4>
        </t-col>
        <t-col :span="6">
          <h4><span>费率标准</span></h4>
        </t-col>
      </t-row>
      <div class="calc-rules-value">
         <t-row style="height: auto; align-items: stretch;">
          <t-col :span="6" style="border-right: 1px solid #DADDE1;">
            <div class="calc-rules-value-left">
              <div class="title"><span>计算范围</span></div>
              <div class="info">{{ calculateRange }}</div>
              <div class="title" style="margin-top: 33px;"><span>计算公式</span></div>
              <div class="info" style="white-space: pre-line;">{{ calculationFormula }}</div>
            </div>
          </t-col>
          <t-col :span="6" style="padding: 20px;overflow: auto;" class='rate-table'>
            <div class="calc-rules-value-right">
              <t-table bordered row-key="index" :data="data" :columns="columns" />
            </div>
          </t-col>
        </t-row>
      </div>
    </div>
    <!-- <help v-bind:visible.sync="helpOpen"></help> -->
    <file-view v-bind:visible.sync="visible" :fileUrl="openFileUrl" :downFileUrl="downFileUrl"></file-view>
  </div>
</template>

<script>
import { getdljsgcdzaqxpj } from '@/api/data'
import { listFile } from "@/api/file";
import { listRate } from "@/api/rate";
// import Help from '@/components/Help.vue'

export default {
  name: 'dljsgcdzaqxpjFee',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    // Help
  },
  data() {
    return {
      jsgc: null,
      visible: false,
      downFileUrl: null,
      openFileUrl: null,
      downLoading: false,
      isxldkygc: false,//是否是线路大跨越工程
      validateMessage: {
        projectName: [
          {
            type: 'error',
            message: '项目名称不能为空',
          },
        ],
        money: [
          {
            type: 'error',
            message: '请输入规范数字',
          },
        ]

      },
      rules: {
        projectName: [{ required: true }, { type: 'warning' }],
        money: [{ required: true }, { pattern: /^[0-9.]*$/, message: '请输入规范数字', required: true, type: 'warning' }],


      },
      optionsprojectType: [
        { label: '燃煤发电工程', value: '燃煤发电工程' },
        { label: '燃气-蒸汽联合循环电站', value: '燃气-蒸汽联合循环电站' },
      ],
      options: [
        { label: '200MW', value: '200MW' },
        { label: '300MW', value: '300MW' },
        { label: '600MW', value: '600MW' },
        { label: '1000MW', value: '1000MW' },
      ],
      helpOpen: false,
      rate: null,
      discountRate: null,
      downData: {},//下载时传值
      rateList: [],
      formData: {
        ificationId: this.$route.query.ification,
        projectName: '',
        projectType: '',
        money: null, //长度和个数
        subcategor: '200MW', //细分类型
        costBasePrice: '30', // 费用基价
        coefficient: '1.0',  // 调整系数
        rate: null,
        subtotal: null, // 收费基价
        discountRate: 0,
        discountRateMoney: null,
        basicCharge: null,//基本收费
        assessmentFee: null,//社会稳定风险评估费
        result: null,
        remark: 1
      },
      resultChinese: '',
      fileList: [],
      costBasePriceLimit: '20~30',
      costBasePriceMin: 20,
      costBasePriceMax: 30,
      projectClassify: '火力发电工程',
      projectType: '燃煤发电工程',
      data: [{

      }],

      columns: [
        {
          title: '序',
          colKey: 'id',
          width: 90,
        },
        {
          title: '收费区间值（万元）',
          width: 100,
          colKey: '-',
          children: [
            {
              colKey: 'startValue',
              title: '起值',
              width: 100,
            },
            {
              title: '终止',
              colKey: 'finalValue',
              width: 100,
            }
          ],
        },
        {
          title: '费率',
          colKey: 'rate',
          width: 100,
        }


      ],
      calculateRange: null,//计算范围
      calculationFormula: null // 计算公式

    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      listFile({ classificationId: this.$route.query.ification }).then(response => {
        // console.log(response)
        this.fileList = response.rows[0];

      });
      listRate({ ificationId: this.$route.query.ification }).then(res => {
        let i = 1
        res.rows.forEach((item) => {
          item.id = i++
          if (item.finalValue > 99999999) {
            item.finalValue = ""
          }
          this.data.push(item)
        })
        this.data = res.rows
      })
      this.getClassification(this.$route.query.ification || 3).then(res => {
        if (res.data.scope) {
          if (res.data.scope.indexOf("\\n") != -1) {
            this.calculateRange = res.data.scope.replaceAll('\\n', '\n')
          } else {
            this.calculateRange = res.data.scope
          }

        } else {
          this.calculateRange = '暂无数据'
        }
        if (res.data.particulars) {
          if (res.data.particulars.indexOf("\\n") != -1) {
            this.calculationFormula = res.data.particulars.replaceAll('\\n', '\n')
          } else {
            this.calculationFormula = res.data.particulars
          }
        } else {
          this.calculationFormula = '暂无数据'
        }
      })
    },
    onReset() {
      this.$message.success('重置成功');
      console.log('formData', this.formData);
    },
    onSubmit({ validateResult, firstError }) {
      if (validateResult === true) {
        this.submit()
        this.$message.success('提交成功');
      } else {
        console.log('Errors: ', validateResult);
        this.$message.warning(firstError);
      }
    },
    downLoadWord(){
      this.downLoading = true;
      let wordParam = {
        xmmc:this.formData.projectName,
        xsz:`工程分类:${this.projectClassify};工程类型:${this.projectType};${this.isxldkygc ? '工作量' : '电站个数'}:${this.formData.money}${this.isxldkygc ? '项' : '个'};${this.isxldkygc ? '' : '细分类型:' + this.formData.subcategor + ';'}费用基价:${this.formData.costBasePrice}万元;调整系数:${this.formData.coefficient};让利利率:${this.discountRate}%。`,
        yjwj:this.fileList ? this.fileList.fileName.split('.')[0] : '--',
        jsgc:this.jsgc,
        fulx:'电力建设工程地震安全性评价',
        zhj:this.formData.result ,
        blxs:this.rate + '%',

        tzxs:this.formData.coefficient,
        gcfl:this.projectClassify,
        gclb:this.projectType,
      }
      this.download('/project/dljsgcdzaqxpj/word', { id: this.downData.id, classId: 81,...wordParam }
        , `全国电力建设工程地震安全性评价费.docx`).then(res => {
          console.log(res)
          this.downLoading = false
        }
        )
    },
    handleClear() {
      this.helpOpen = true
    },
    submit() {
      this.formData.remark = 1
      this.formData.rate = Number(this.rate) / 100
      this.formData.discountRate = Number(this.discountRate) / 100
      getdljsgcdzaqxpj(this.formData).then(res => {
        this.downData = res.data
        this.formData.money = res.data.money.toString()
        this.formData.discountRateMoney = res.data.discountRateMoney.toFixed(2).toString()
        this.formData.result = res.data.result.toFixed(2).toString()
        this.formData.subtotal = res.data.subtotal.toFixed(2).toString()
        this.formData.basicCharge = res.data.basicCharge.toFixed(2).toString()
        this.formData.assessmentFee = res.data.assessmentFee.toFixed(2).toString()
        // this.formData.money.toString()
        this.resultChinese = this.changeNumMoneyToChinese(Number(this.formData.result))
        this.jsgc = res.data.jsgc
      })
    },
    resultChange(value) {
      this.resultChinese = this.changeNumMoneyToChinese(value)
    },
    changeprojectClassify(value) {
      if (value == '火力发电工程') {
        this.optionsprojectType = [
          { label: '燃煤发电工程', value: '燃煤发电工程' },
          { label: '燃气-蒸汽联合循环电站', value: '燃气-蒸汽联合循环电站' },
        ]
        this.projectType = '燃煤发电工程'
        this.formData.subcategor = '200MW'
        this.costBasePriceLimit = '10~20'
        this.costBasePriceMin = 10,
          this.costBasePriceMax = 20,
          this.formData.costBasePrice = '20'
      } else if (value == '电网工程') {
        this.optionsprojectType = [
          { label: '直流工程', value: '直流工程' },
          { label: '交流工程', value: '交流工程' },
          { label: '线路大跨越工程', value: '线路大跨越工程' }
        ]
        this.projectType = '直流工程'
        this.formData.subcategor = '±800kV'
        this.costBasePriceLimit = '20~40'
        this.costBasePriceMin = 20,
          this.costBasePriceMax = 40,
          this.formData.costBasePrice = '40'

        this.options = [
          { label: '±800kV', value: '±800kV' },
          { label: '±660kV', value: '±660kV' },
          { label: '±500kV', value: '±500kV' },
          { label: '±400kV', value: '±400kV' }
        ]

      }
    },
    changeprojectType(value) {
      console.log(value)
      if (value == '燃煤发电工程') {
        this.options = [
          { label: '200MW', value: '200MW' },
          { label: '300MW', value: '300MW' },
          { label: '600MW', value: '600MW' },
          { label: '1000MW', value: '1000MW' }
        ]
        this.formData.subcategor = '200MW'
        this.costBasePriceLimit = '10~20'
        this.costBasePriceMin = 10,
          this.costBasePriceMax = 20,
          this.formData.costBasePrice = '20'

        this.isxldkygc = false
      } else if (value == '燃气-蒸汽联合循环电站') {
        this.options = [
          { label: '9E级', value: '9E级' },
          { label: '9F级', value: '9F级' }
        ]
        this.formData.subcategor = '9E级'
        this.costBasePriceLimit = '20~30'
        this.costBasePriceMin = 20,
          this.costBasePriceMax = 30,
          this.formData.costBasePrice = '30'

        this.isxldkygc = false
      } else if (value == '直流工程') {
        this.options = [
          { label: '±800kV', value: '±800kV' },
          { label: '±660kV', value: '±660kV' },
          { label: '±500kV', value: '±500kV' },
          { label: '±400kV', value: '±400kV' }
        ]
        this.formData.subcategor = '±800kV'
        this.costBasePriceLimit = '20~40'
        this.costBasePriceMin = 20,
          this.costBasePriceMax = 40,
          this.formData.costBasePrice = '40'

        this.isxldkygc = false
      } else if (value == '交流工程') {
        this.options = [
          { label: '1000kV', value: '1000kV' },
          { label: '750kV', value: '750kV' },
          { label: '500kV', value: '500kV' },
          { label: '330kV', value: '330kV' },
          { label: '220kV', value: '220kV' }
        ]
        this.formData.subcategor = '1000kV'
        this.costBasePriceLimit = '20~40'
        this.costBasePriceMin = 20,
          this.costBasePriceMax = 40,
          this.formData.costBasePrice = '40'

        this.isxldkygc = false
      } else if (value == '线路大跨越工程') {
        this.formData.subcategor = null
        this.costBasePriceLimit = '15~25'
        this.costBasePriceMin = 15,
          this.costBasePriceMax = 25,
          this.formData.costBasePrice = '25'

        this.isxldkygc = true
      }
    },
    changeSubcategor(value) {
      if (value == '200MW' || value == '9E级') {
        this.costBasePriceLimit = '10~20'
        this.costBasePriceMin = 10,
          this.costBasePriceMax = 20,
          this.formData.costBasePrice = '20'
      } else if (value == '300MW' || value == '500kV' || value == '330kV') {
        this.costBasePriceLimit = '15~30'
        this.costBasePriceMin = 15,
          this.costBasePriceMax = 30,
          this.formData.costBasePrice = '30'
      } else if (value == '600MW' || value == '±800kV' || value == '1000kV') {
        this.costBasePriceLimit = '20~40'
        this.costBasePriceMin = 20,
          this.costBasePriceMax = 40,
          this.formData.costBasePrice = '40'
      } else if (value == '1000MW') {
        this.costBasePriceLimit = '30~60'
        this.costBasePriceMin = 30,
          this.costBasePriceMax = 60,
          this.formData.costBasePrice = '60'
      } else if (value == '9F级' || value == '220kV') {
        this.costBasePriceLimit = '15~25'
        this.costBasePriceMin = 15,
          this.costBasePriceMax = 25,
          this.formData.costBasePrice = '25'
      } else if (value == '±660kV' || value == '±500kV' || value == '±400kV') {
        this.costBasePriceLimit = '20~30'
        this.costBasePriceMin = 20,
          this.costBasePriceMax = 30,
          this.formData.costBasePrice = '30'
      } else if (value == '750kV') {
        this.costBasePriceLimit = '15~35'
        this.costBasePriceMin = 15,
          this.costBasePriceMax = 35,
          this.formData.costBasePrice = '35'
      }
    },

  },
  computed: {
    inputStatus() {
      if (this.formData.costBasePrice < this.costBasePriceMin || this.formData.costBasePrice > this.costBasePriceMax) {
        return 'error';
      } if (isNaN(+this.formData.costBasePrice)) {
        return 'warning';
      }
      return '';
    },
    tips() {
      if (this.inputStatus == 'error') {
        return '请输入合理区间数字';
      } else if (this.inputStatus == 'warning') {
        return '请输入规范数字';
      }
      return '';
    },
    inputStatus2() {
      if (isNaN(+this.discountRate)) {
        return 'error';
      }
      return '';
    },
    tips2() {
      if (!this.inputStatus2) {
        return '';
      }
      return '请输入数字';
    },
    inputStatus3() {
      if (isNaN(+this.formData.coefficient)) {
        return 'error';
      }
      return '';
    },
    tips3() {
      if (!this.inputStatus3) {
        return '';
      }
      return '请输入数字';
    },
  },

}
</script>

<style lang="less">
.dljsgcdzaqxpj {
  background: #ffffff;
  width: 1168px;
  margin: 0 auto;
  border: 1px solid #e3e6ea;
  padding-bottom: 38px;


  
}
</style>
